import { render, staticRenderFns } from "./product_details_one.vue?vue&type=template&id=4eff47ce&scoped=true&"
import script from "./product_details_one.vue?vue&type=script&lang=js&"
export * from "./product_details_one.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eff47ce",
  null
  
)

export default component.exports